import React from 'react'
import { BarChart3, Users, Brain } from 'lucide-react'

const Credibility: React.FC = () => {
  const stats = [
    {
      icon: BarChart3,
      number: '10,000+',
      label: '글로벌 게시물 스캔'
    },
    {
      icon: Users,
      number: '15개',
      label: '해외 커뮤니티 분석'
    },
    {
      icon: Brain,
      number: '100+',
      label: '자체 분석 정교화 기능'
    }
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            매주 이만큼 분석합니다
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-8 bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <stat.icon className="w-8 h-8 text-white" />
              </div>
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                {stat.number}
              </div>
              <div className="text-lg text-gray-700 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            매주 수천 개의 글로벌 AI 커뮤니티와 전문가들의 인사이트를 
            분석하여 가장 중요한 트렌드만을 선별해 전달합니다.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Credibility
